<template>
  <div class="row">
    <!--  用户信息  -->
    <div class="flex xs10 offset--xs1">
      <va-card title="导师信息">
        <div class="row">
          <div class="flex xs12">
            <va-button flat disabled color="gray">查看服务：</va-button>
            <va-button outline color="info" @click="$router.push({ name: 'listConsulting', query: {mentorUid: $route.params.uid}})">提供咨询</va-button>
            <va-button outline color="info" @click="$router.push({ name: 'listOfferedCourse', query: {mentorUid: $route.params.uid}})" >提供课程</va-button>
            <va-button outline color="info" @click="$router.push({ name: 'listComment', query: {toUid: $route.params.uid}})">收到的评论</va-button>
            <va-button outline color="success" @click="translateUnfilledFields">一件翻译绿色Field</va-button>
          </div>
          <div class='flex md6 sm6 xs12' v-show="insertData.avatar.length!==0">
            <va-card
              overlay
              :image='insertData.avatar'
              class="va-card-image"
              title="头像"
            >
            </va-card>
          </div>
          <div class='flex md6 sm6 xs12'>
            <va-card title='上传头像'>
              <va-file-upload
                type='single'
                v-model='insertData.avatarArr'
                @input="uploadAvatar"
              />
            </va-card>
          </div>
          <div class='flex md6 sm6 xs12'>
            <va-input
              v-model='insertData.uid'
              label='用户uid'
              disabled
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.nickname"
              label="姓名"
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.briefInfo"
              label="一句话介绍自己"
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.briefInfoEn"
              label="一句话介绍自己(英文)"
              success
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              type="textarea"
              v-model="insertData.info"
              label="个人简介"
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              type="textarea"
              v-model="insertData.infoEn"
              label="个人简介(英文)"
              success
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              type="textarea"
              v-model="insertData.skill"
              label="擅长技能"
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              type="textarea"
              v-model="insertData.skillEn"
              label="擅长技能(英文)"
              success
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-tree-category isOpen label="职业背景(左边中文, 右边英文)">
              <va-tree-node
                v-for="career in insertData.careerBackgrounds"
                :key="career.serviceId"
              >
                <div class="flex row align--center">
                  <va-input v-model="career.title" removable class="mb-0 flex md5 sm6 xs12"/>
                  <va-input v-model="career.titleEn" removable class="mb-0 flex md5 sm6 xs12" success/>
                  <va-icon
                    name="ion ion-md-close"
                    color="info"
                    class="ml-2 pa-1 shrink"
                    style="cursor: pointer;"
                    @click.native="removeCareer(career)"
                  />
                </div>
              </va-tree-node>
              <va-tree-node>
                <va-button class="mb-2" small @click="addCareer()">
                  新增职业背景
                </va-button>
              </va-tree-node>
            </va-tree-category>
          </div>
          <div class="flex md12 sm6 xs12">
            <va-tree-category isOpen label="教育背景(左边中文, 右边英文)">
              <va-tree-node
                v-for="education in insertData.educationBackgrounds"
                :key="education.serviceId"
              >
                <div class="flex row align--center">
                  <va-input v-model="education.title" removable class="mb-0 flex md5 sm6 xs12"/>
                  <va-input v-model="education.titleEn" removable class="mb-0 flex md5 sm6 xs12" success/>
                  <va-icon
                    name="ion ion-md-close"
                    color="info"
                    class="ml-2 pa-1 shrink"
                    style="cursor: pointer;"
                    @click.native="removeEducation(education)"
                  />
                </div>
              </va-tree-node>
              <va-tree-node>
                <va-button class="mb-2" small @click="addEducation()">
                  新增职业背景
                </va-button>
              </va-tree-node>
            </va-tree-category>
          </div>
          <div class="flex md12 sm6 xs12"><va-button flat disabled color="red">备注：绑定内推公司用于给内推的详情页推荐导师</va-button></div>
          <div class="flex md4 sm6 xs12">
            <va-select
              label="可内推公司"
              v-model="insertData.organization.name"
              searchable
              :options="computedOrganizations"
              :messages="message"
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-select
              label="擅长领域"
              v-model="insertData.mentorExpertFieldIds"
              multiple
              :options="computedMentorExpertFields"
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-select
              label="所处行业"
              v-model="insertData.mentorIndustryIds"
              multiple
              :options="computedMentorIndustries"
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              label="社交帐户链接"
              v-model="insertData.socialMediaLink"
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-select
              label="是否活跃"
              v-model="insertData.isActive"
              :options="isActiveOptions"
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-select
              label="发消息权限"
              v-model="insertData.msgPermission"
              :options="msgPermissionOptions"
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-select
              label="是否是王牌导师"
              v-model="insertData.ace"
              :options="aceOptions"
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              v-model="insertData.sortNum"
              label="排序"
              placeholder="数字越大越靠前"
              removable
              oninput="if(value<0)value=1"
              type="number"
              :min="1"
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              v-model="insertData.createTime"
              label="成为导师时间"
            />
          </div>
          <div class="flex md6 sm6 xs12 justify--end">
            <div class="d-flex justify--end">
              <va-button class="mb-2" outline color="info" slot="trigger" @click="clickSubmitMentorInfo" :disabled="!submitButtonStatus">
                保存导师信息
              </va-button>
            </div>
          </div>
          <div class="flex md6 sm6 xs12">
            <va-button class="mb-2" outline color="gray" slot="trigger" @click="$router.push({ name: 'listMentor'})" :disabled="!submitButtonStatus">
              返回导师列表
            </va-button>
          </div>
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>

import 'vue-trix'
import { copyObject, formatTime, translateData } from '@/utils/common'
import mentorApi from '../../api/mentor'
import uploadApi from '../../api/upload'
import tagApi from '../../api/tag'
import { TAG_TYPE } from '@/utils/constants'
import organizationApi from '@/api/organization'
export default {
  data () {
    return {
      insertData: {
        uid: '',
        nickname: '',
        avatar: '',
        avatarArr: [],
        info: '',
        infoEn: '',
        briefInfo: '',
        briefInfoEn: '',
        skill: '',
        skillEn: '',
        createTime: '',
        mentorResumeUrl: '',
        socialMediaLink: '',
        msgPermission: null,
        isActive: null,
        sortNum: null,
        mentorExpertFieldIds: [],
        mentorIndustryIds: [],
        careerBackgrounds: [],
        educationBackgrounds: [],
        organization: { name: '' },
        ace: null,
      },
      downgradeModal: false,
      status: null,
      message: ['可以更改'],
      title: '新增用户',
      mentorIndustries: [],
      mentorExpertFields: [],
      isActiveOptions: ['是', '否'],
      aceOptions: ['是', '否'],
      msgPermissionOptions: ['是', '否'],
      submitButtonStatus: true,
      organizations: [],
    }
  },
  created () {
    this.getMentor()
    this.listMentorExpertField()
    this.listMentorIndustry()
    this.listOrganization()
  },
  computed: {
    computedMentorExpertFields () {
      return this.mentorExpertFields.map(x => {
        return x.name
      })
    },
    computedMentorIndustries () {
      return this.mentorIndustries.map(x => {
        return x.name
      })
    },
    computedOrganizations () {
      return this.organizations.map(x => {
        return x.name
      })
    },
    flipMentorExpertFields () {
      const flipMentorExpertFields = {}
      this.mentorExpertFields.forEach(x => {
        flipMentorExpertFields[x.name] = x.id
      })
      return flipMentorExpertFields
    },
    flipMentorIndustries () {
      const flipMentorIndustries = {}
      this.mentorIndustries.forEach(x => {
        flipMentorIndustries[x.name] = x.id
      })
      return flipMentorIndustries
    },
    flipOrganizations () {
      const flipOrganizations = {}
      this.organizations.forEach(x => {
        flipOrganizations[x.name] = x.id
      })
      return flipOrganizations
    },
  },
  methods: {
    getMentor () {
      const params = this.$route.params
      if (params.uid != null) {
        this.title = '查看导师： ' + this.insertData.nickname
        // 通过id获取详情
        mentorApi.getMentor(params.uid).then(response => {
          copyObject(response.mentor, this.insertData)
          this.insertData.createTime = formatTime(this.insertData.createTime)
          // eslint-disable-next-line no-prototype-builtins
          if (response.mentor.hasOwnProperty('isActive')) {
            this.insertData.isActive = response.mentor.isActive ? '是' : '否'
          }
          // eslint-disable-next-line no-prototype-builtins
          if (response.mentor.hasOwnProperty('msgPermission')) {
            this.insertData.msgPermission = response.mentor.msgPermission ? '是' : '否'
          }
          // eslint-disable-next-line no-prototype-builtins
          if (response.mentor.hasOwnProperty('ace')) {
            this.insertData.ace = response.mentor.ace === 0 ? '否' : '是'
          }
          // eslint-disable-next-line no-prototype-builtins
          if (response.hasOwnProperty('mentorExpertFields') && response.mentorExpertFields.length !== 0) {
            const that = this
            that.insertData.mentorExpertFieldIds = []
            response.mentorExpertFields.forEach(x => {
              that.insertData.mentorExpertFieldIds.push(x.name)
            })
          }
          // eslint-disable-next-line no-prototype-builtins
          if (response.hasOwnProperty('mentorIndustries') && response.mentorIndustries.length !== 0) {
            const that = this
            that.insertData.mentorIndustryIds = []
            response.mentorIndustries.forEach(x => {
              that.insertData.mentorIndustryIds.push(x.name)
            })
          }
          // eslint-disable-next-line no-prototype-builtins
          if (response.hasOwnProperty('careerBackgrounds')) {
            this.insertData.careerBackgrounds = response.careerBackgrounds
          }
          // eslint-disable-next-line no-prototype-builtins
          if (response.hasOwnProperty('educationBackgrounds')) {
            this.insertData.educationBackgrounds = response.educationBackgrounds
          }
          // eslint-disable-next-line no-prototype-builtins
          if (response.organization.hasOwnProperty('name')) {
            this.insertData.organization.name = response.organization.name
          }
        }).catch(error => {
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      }
    },
    listMentorExpertField () {
      tagApi.listTag({ tagType: TAG_TYPE.EXPERT_FIELD_TAG.CODE }).then(response => {
        this.mentorExpertFields = response.tags
      }).catch(error => {
        console.log(error)
      })
    },
    listMentorIndustry () {
      tagApi.listTag({ tagType: TAG_TYPE.INDUSTRY_TAG.CODE }).then(response => {
        this.mentorIndustries = response.tags
      }).catch(error => {
        console.log(error)
      })
    },
    listOrganization () {
      const params = {
        pageNumber: 1,
        pageSize: 100000,
      }
      organizationApi.listOrganization(params).then(response => {
        this.organizations = response.organizations
      }).catch(error => {
        console.log(error)
      })
    },
    resetStatus () {
      this.status = null
    },
    addCareer () {
      this.insertData.careerBackgrounds.push(
        { title: '公司•职位', titleEn: 'organization•position' },
      )
    },
    removeCareer (career) {
      this.insertData.careerBackgrounds = this.insertData.careerBackgrounds.filter(x => x !== career)
    },
    addEducation () {
      this.insertData.educationBackgrounds.push(
        { id: Math.floor(Math.random() * 100000), title: '学校•专业', titleEn: 'university•major' },
      )
    },
    removeEducation (education) {
      this.insertData.educationBackgrounds = this.insertData.educationBackgrounds.filter(x => x !== education)
    },
    clickSubmitMentorInfo () {
      this.changeButtonStatus(false)
      const data = {
        socialMediaLink: this.insertData.socialMediaLink,
        sortNum: this.insertData.sortNum,
        isActive: this.insertData.isActive === '是',
        msgPermission: this.insertData.msgPermission === '是',
        organizationId: this.flipOrganizations[this.insertData.organization.name],
        ace: this.insertData.ace === '是' ? 1 : 0,
        mentorExpertFieldIds: this.insertData.mentorExpertFieldIds.map(name => {
          return this.flipMentorExpertFields[name]
        }),
        mentorIndustryIds: this.insertData.mentorIndustryIds.map(name => {
          return this.flipMentorIndustries[name]
        }),
        user: {
          uid: this.insertData.uid,
          nickname: this.insertData.nickname,
          avatar: this.insertData.avatar,
          sortNum: this.insertData.sortNum,
          info: this.insertData.info,
          infoEn: this.insertData.infoEn,
          briefInfo: this.insertData.briefInfo,
          briefInfoEn: this.insertData.briefInfoEn,
          skill: this.insertData.skill,
          skillEn: this.insertData.skillEn,
          careerBackgrounds: this.insertData.careerBackgrounds,
          educationBackgrounds: this.insertData.educationBackgrounds,
        },
      }
      if (this.insertData.uid != null) {
        data.mentorUid = this.insertData.uid
        mentorApi.updateMentor(data.mentorUid, data).then(response => {
          if (response.success != null) {
            this.getMentor()
            this.changeButtonStatus(true)
            this.showToast('导师信息更新成功', {
              duration: 1000,
              icon: 'fa-success',
              position: 'top-center',
              fullWidth: false,
            })
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      }
      this.resetStatus()
    },
    clickCancel () {
    },
    uploadAvatar () {
      if (this.insertData.avatarArr.length === 0) return
      const formData = new FormData()
      formData.append('type', 'image')
      formData.append('file', this.insertData.avatarArr[this.insertData.avatarArr.length - 1])
      uploadApi.uploadImage(formData).then(response => {
        this.insertData.avatar = response.url
        this.showToast('上传图片成功', {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    changeButtonStatus (status) {
      this.submitButtonStatus = status
    },
    async translateUnfilledFields () {
      // 个人简介
      if (this.insertData.info !== '' && this.insertData.infoEn === '') {
        this.insertData.infoEn = await translateData(this.insertData.info)
      }
      // 一句话介绍自己
      if (this.insertData.briefInfo !== '' && this.insertData.briefInfoEn === '') {
        this.insertData.briefInfoEn = await translateData(this.insertData.briefInfo)
      }
      // 擅长技能
      if (this.insertData.skill !== '' && this.insertData.skillEn === '') {
        this.insertData.skillEn = await translateData(this.insertData.skill)
      }
      await this.translateBackgrounds(this.insertData.careerBackgrounds)
      await this.translateBackgrounds(this.insertData.educationBackgrounds)
    },
    async  translateBackgrounds (educationBackgrounds) {
      const translationPromises = educationBackgrounds.map(async (x, index) => {
        if (x.title && !x.titleEn) {
          try {
            educationBackgrounds[index].titleEn = await translateData(x.title)
          } catch (error) {
            console.error(`翻译背景 ${index} 时出现错误:`, error)
          }
        }
      })
      await Promise.all(translationPromises)
    },
  },
}

</script>

<style>
.va-card-image {
  height: 200px;
  width: 200px;
  border-radius: 5%;
  margin-bottom: 10px;
}
</style>
